module.exports = __webpack_public_path__ + "media/icons/youtube@2x-c5c48d4b.png";